import { Project, ProjectLog, User, invoiceControlStatusConfig } from 'entities';

import { executeApiCall } from 'services/api';
import { getLoaders } from 'entities/hooks/load';
import { InvoiceProjectByStatus, ProjectInvoiceControlCancelRequest } from '../types';

interface InvoiceProjectsByStatusParams {
  status: string;

  limit?: number;
  paginationToken?: string;
  startDate?: string;
  endDate?: string;
  owner?: string[];
  type?: InvoiceProjectByStatus['type'];
}

const invoiceProjectsByStatus = async ({
  status,
  ...payload
}: InvoiceProjectsByStatusParams): Promise<{
  projects: InvoiceProjectByStatus[];
  paginationToken?: string;
}> => {
  return executeApiCall({
    path: `/invoice/projects/${status}`,

    method: 'get',

    payload,
  });
};

export const invoiceProjectsLoaders = getLoaders({
  invoiceProjectsCounts: {
    load: async (): Promise<Record<string, number>> => {
      return executeApiCall({
        path: '/invoice/projects/counts',

        method: 'get',
      });
    },
  },

  invoiceProjectsByStatus: {
    load: invoiceProjectsByStatus,
  },

  unassignedInvoiceControls: {
    load: async () => {
      const { projects } = await invoiceProjectsByStatus({
        status: invoiceControlStatusConfig.unassigned.code,
      });

      return projects;
    },
  },

  invoiceControlByUsers: {
    load: async (): Promise<
      Record<
        string,
        {
          total: number;
          user: User;
          controls: InvoiceProjectByStatus[];
        }
      >
    > => {
      return executeApiCall({
        path: `/invoice/projects/by-users`,

        method: 'get',
      });
    },
  },

  invoiceControlEvents: {
    load: async ({ projectId }: { projectId: string }): Promise<ProjectLog[]> => {
      return executeApiCall({
        path: `/invoice/projects/${projectId}/logs`,

        method: 'get',
      });
    },
  },

  invoiceControlCancelRequests: {
    load: async (): Promise<
      Array<Omit<ProjectInvoiceControlCancelRequest, 'project'> & { project: Project }>
    > => {
      return executeApiCall({
        path: `/invoice/projects/cancel/active-requests`,

        method: 'get',
      });
    },
  },
});
